import { Typography } from "@mui/material";
import { useStyles } from "../RCACompliance.styles";
import { useTranslation } from "react-i18next";
import { useContext, useState, useEffect, useMemo } from "react";
import { RCACorporateDashboardEntity } from "entities/RCA/RCACorporateDashboardEntity/RCACorporateDashboardEntity";
import { IRcaMethodologyUsedByMill } from "entities/RCA/RCACorporateDashboardEntity/RCACorporateDashboardEntityInterfaces";
import { RCACorporateDashboardContext } from "contexts/RCACorporateDashboardContext/RCACorporateDashboardContext";
import moment from "moment";
import RCAWithNoMethodologyByMillModal from "./RCAWithNoMethodologyByMillModal";

const RCAMethodologyByMill = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { filters } = useContext(RCACorporateDashboardContext);
    const [summaryData, setSummaryData] = useState({ fiveWhys: 0, fishbone: 0 });
    const [millSelected, setMillSelected] = useState<IRcaMethodologyUsedByMill>();
    const [openRCAWithNoMethodologyModal, setOpenRCAWithNoMethodologyModal] = useState<boolean>(false);
    const argsFilters = useMemo(
        () => ({
            date: moment().subtract(Number(filters.periodOption), "day").startOf("day").toISOString(),
            divisionIds: filters.divisionIds,
            totalDivisions: filters.totalDivisions,
            regionIds: filters.regionIds,
            totalRegions: filters.totalRegions,
        }),
        [filters],
    );
    const { rcaMethodologyUsedByMill } = RCACorporateDashboardEntity.GetRcaMethodologyUsedByMill(argsFilters);

    useEffect(() => {
        if (rcaMethodologyUsedByMill && rcaMethodologyUsedByMill.length > 0) {
            const fiveWhys =
                rcaMethodologyUsedByMill.reduce((acc, m) => acc + Number(m.five_why_percentage), 0) /
                rcaMethodologyUsedByMill.length;
            const fishbone =
                rcaMethodologyUsedByMill.reduce((acc, m) => acc + Number(m.fishbone_percentage), 0) /
                rcaMethodologyUsedByMill.length;
            setSummaryData({ fiveWhys, fishbone });
        } else {
            setSummaryData({ fiveWhys: 0, fishbone: 0 });
        }
    }, [rcaMethodologyUsedByMill]);

    return (
        <>
            <div className={classes.card}>
                <div className={classes.tableHeader}>
                    <Typography variant="rcaTitle" className={classes.cardTitle}>
                        {t("rca.compliance.rca_compliance.rca_methodology_used.title")}
                    </Typography>
                </div>
                <table className={classes.table}>
                    {rcaMethodologyUsedByMill.length > 0 ? (
                        <>
                            <thead>
                                <tr>
                                    <th className={classes.th}>{t("rca.corporate_dashboard.rca_compliance.mill")}</th>
                                    <th className={classes.th}>
                                        {t("rca.compliance.rca_compliance.rca_methodology_used.fiveWHYS")}
                                    </th>
                                    <th className={classes.th}>
                                        {t("rca.compliance.rca_compliance.rca_methodology_used.fishbone")}
                                    </th>
                                    <th className={classes.th}>
                                        {t("rca.compliance.rca_compliance.rca_methodology_used.none")}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {rcaMethodologyUsedByMill.map((row) => (
                                    <tr key={row.mill_id}>
                                        <td className={classes.thTd}>
                                            <div className={classes.userNameContainer}>{row.name}</div>
                                        </td>
                                        <td className={classes.thTd}>{row.five_why_percentage}%</td>
                                        <td className={classes.thTd}>{row.fishbone_percentage}%</td>
                                        <td
                                            onClick={() => {
                                                setMillSelected(row);
                                                setOpenRCAWithNoMethodologyModal(true);
                                            }}
                                            className={classes.thTdHighlighted}
                                        >
                                            {row.none_percentage}%
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td className={classes.tfootTd}>
                                        {t("rca.compliance.rca_compliance.rca_methodology_used.total")}
                                    </td>
                                    <td className={classes.tfootTd}>{summaryData.fiveWhys}%</td>
                                    <td className={classes.tfootTd}>{summaryData.fishbone}%</td>
                                    <td className={classes.tfootTd}></td>
                                </tr>
                            </tfoot>
                        </>
                    ) : (
                        <p className={classes.noData}>
                            {t("rca.compliance.rca_compliance.rca_methodology_used.noDataFound")}
                        </p>
                    )}
                </table>
            </div>
            <RCAWithNoMethodologyByMillModal
                open={openRCAWithNoMethodologyModal}
                handleClose={() => setOpenRCAWithNoMethodologyModal(false)}
                data={millSelected}
            />
        </>
    );
};

export default RCAMethodologyByMill;
